import React, { useState } from 'react';
import type { Nullable } from 'corgi-types';

import { Flex } from 'common/components/Flex';
import type { GiftCardStatus as GiftCardStatusType } from '../types/gift-card';
import { isValidGiftCardStatus } from '../utils/gift-card';
import Form from './Form';
import GiftCardStatus from './GiftCardStatus';

const CheckGiftCardBalanceForm = () => {
  const [giftCardStatus, setGiftCardStatus] = useState<Nullable<GiftCardStatusType>>(null);

  const onRestartButtonClick = () => {
    window.location.reload();
  };

  return (
    <Flex
      data-corgi-id="check-gift-card-balance-form"
      alignItems={['flex-start', 'center']}
      flexDirection="column"
      px="sp_16"
    >
      {isValidGiftCardStatus(giftCardStatus) ? (
        <GiftCardStatus {...giftCardStatus} onRestartButtonClick={onRestartButtonClick} />
      ) : (
        <Form setGiftCardStatus={setGiftCardStatus} />
      )}
    </Flex>
  );
};

export default CheckGiftCardBalanceForm;
